import * as React from "react";
import { FieldSet } from "../modelDialogs/BaseDialog";
import type DeviceTemplate from "../models/DeviceTemplate";

import Logger from "../Logger";
const logger = new Logger();

export default function DetermineTemplateComparbility(props: { template: DeviceTemplate }) {
  const { template } = props;

  return (
    <div
      className="determineTemplateComparbility"
      style={{
        padding: "5px 20px",
        display: "flex",
        flexFlow: "wrap",
      }}
    >
      <FieldSet key="remarcs">
        <input></input>
      </FieldSet>
    </div>
  );
}
